// App Imports
import { isEmpty } from '../../../setup/helpers'
import moment from 'moment'
import {
  BILL_GET_ACCOUNT_BILLS_REQUEST,
  BILL_GET_ACCOUNT_BILLS_RESPONSE,
  BILL_GET_ACCOUNT_BILLS_FAILURE,
  BILL_ACCOUNT_BILLS_RESET,
  BILL_UPDATE_NEW_ACCOUNT_BILL_IN_PROGRESS,
  SET_BILL_LIST,
  SET_ERROR,
  BILL_GET_PM_BILLS_REQUEST,
  BILL_GET_PM_BILLS_RESPONSE,
  SET_PM_BILL_LIST,
  BILL_GET_OWED_ACCOUNTS_REQUEST,
  BILL_GET_OWED_ACCOUNTS_RESPONSE
} from './actions'

const today = moment().format("MM/DD/YYYY");
const dueDate = moment().add(14, 'd').format("MM/DD/YYYY");
// Initial State
const billsInitialState = {
  isLoading: true,
  error: null,
  data: {
    items: []
  },
  newBill: {
    vendorBillUUID: -1,
    vendorID: null,
    fiscalMonth: 0,
    dueDate: dueDate,
    tariffRateTotal: 0,
    kwhUsedTotal: 0,
    fiscalYear: 0,
    billDate: today,
    marketRateTotal: 0,
    kwhTotal: 0,
    meterReadDate: "",
    serviceStartDate: "",
    serviceEndDate: "",
    billTotal: 0,
    costPerKWH: 0,
    // Each table consists of 3 sub arrays:
    newBillLineItems: {
      items: [],
      toDelete: [], // Array of uuids
      toUpdate: []  // Array of uuids
    }
  },
  pmBillPacketIsLoading: true,
  pmBillPackets: {
    items: [],
    toDelete: [],
    toUpdate: [],
  },
  accountBillsOwed: {
    items: []
  },
  accountBillsOwedLoading: true,
  pmBillPacketsSummary: null,
}

// State
export default (state = billsInitialState, action) => {
  switch (action.type) {
    case SET_BILL_LIST:
      return {
        ...state,
        data: action.data,
      }

    case SET_PM_BILL_LIST:
      var newStateData = state.pmBillPackets.items;
      if (action.resetCache || action.clearCache) {
        let pmBills = {
          items: action.data.items,
          toDelete: [],
          toUpdate: [],
        };
        newStateData = pmBills;
      }
      else {
        let pmBills = {
          items: newStateData.concat(action.data.items),
          toDelete: [],
          toUpdate: [],
        };
        newStateData = pmBills;
      }
      if (action.isBaseGroup) {
        return {
          ...state,
          pmBillPacketsSummary: action.data.summary
        };
      }
      else {
        return {
          ...state,
          pmBillPackets: newStateData,
          pmBillPacketsSummary: action.data.summary
        };
      }

    case BILL_GET_PM_BILLS_REQUEST:
      return {
        ...state,
        pmBillPacketIsLoading: action.isLoading,
        error: null
      }

    case BILL_GET_PM_BILLS_RESPONSE:
      return {
        ...state,
        pmBillPacketIsLoading: false,
        error: action.error
      }

    case BILL_GET_OWED_ACCOUNTS_REQUEST:
      return {
        ...state,
        accountBillsOwedLoading: action.isLoading,
        error: null
      }

    case BILL_GET_OWED_ACCOUNTS_RESPONSE:
      return {
        ...state,
        accountBillsOwedLoading: false,
        accountBillsOwed: action.response,
        error: action.error
      }

    case BILL_GET_ACCOUNT_BILLS_REQUEST:
      return {
        ...state,
        isLoading: action.isLoading,
        error: null
      }

    case BILL_GET_ACCOUNT_BILLS_RESPONSE:
      if (action.data) {
        return {
          ...state,
          isLoading: false,
          error: action.error,
          data: action.data
        }
      }
      else {
        return {
          ...state,
          isLoading: false,
          error: action.error,
        }
      }


    case BILL_GET_ACCOUNT_BILLS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.error
      }
    case BILL_UPDATE_NEW_ACCOUNT_BILL_IN_PROGRESS:
      // Merges the old and new property objects together
      const newBillUpdated = Object.assign({}, state.newBill, action.newBillData);
      return {
        ...state,
        newBill: newBillUpdated,
      }
    case BILL_ACCOUNT_BILLS_RESET:
      return Object.assign({}, billsInitialState)

    case SET_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.error
      }

    default:
      return state;
  }
}